export default function fn(value = '', options = {}) {
  return options.fn(value, options);
}

fn.message = function message(value, options = {}) {
  return options.message || 'não é válido';
};
